import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import styles from './PrimeiroAcesso.scss';
import LoginBackground from './../../assets/images/login-background.jpg';
import { openModal } from '../../store/modules/ModalActions';
import PrimeiroAcessoModal from '../../components/PrimeiroAcessoModal/PrimeiroAcessoModal';
import { getApis } from 'library/Apis';
import { logoutPath } from 'library/Routes';
const rootClassName = styles.rootClassName;

class PrimeiroAcesso extends Component {
  getCpfFromURL = () => {
    const url = new URL(window.location);
    return url.searchParams.get('user') || null;
  };

  componentDidMount() {
    const user = this.getCpfFromURL();
    this.props.openModal(PrimeiroAcessoModal, {
      cpf: user,
      cancelCallback: () => {
        this.redirectToRoot();
      },
      savedCallback: () => {
        this.redirectToLogin();
      },
    });
  }

  redirectToLogin = () => {
    const { authUrl, identityClientId, redirectUrl } = getApis().auth;
    const loginUrl = `${authUrl}?client_id=${identityClientId}&redirect_uri=${encodeURIComponent(
      redirectUrl
    )}&origin=external&response_type=id_token%20token&scope=openid%20profile%20email`;
    window.location.href = loginUrl;
  };

  redirectToRoot = () => {
    this.props.history.push(logoutPath);
  };

  render() {
    return (
      <div
        className={rootClassName}
        style={{
          backgroundImage: 'url(' + LoginBackground + ')',
        }}
      >
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PrimeiroAcesso));
